import {
  formatDate,
  RootState,
  secureMessageDetailsRequest,
} from '@rb-serve-app/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../components/Spinner';
import moment from 'moment';
type MessageDetails = {
  confirmationNumber?: string;
  category?: string;
  comments?: string;
  lastUpdatedBy?: string;
  lastUpdatedTime?: string;
  reason?: string;
  referenceNumber?: string;
  requestDate?: string;
  requestType?: string;
  status?: string;
  agentComments?: any;
};

interface Item {
  key: string;
  value: string;
}

export default function ViewMessageDetail({ messageId }: any) {
  console.log('messageIdView', messageId);
  const { customerId, accountId, accountDetails } = useSelector(
    (state: RootState) => state.user
  );
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries, assets } = contentfulData;

  const { rb_secure_message } = entries;
  const { secureMessageErrorInfo, secureMessageListInfo } = rb_secure_message;
  const { categoryListForWeb } = secureMessageListInfo || {};
  const [localLoader, setLocalLoader] = useState(false);
  const contactInfo = useSelector((state: RootState) => state?.contactInfo);
  const [messageDetails, setMessageDetails] = useState<MessageDetails | null>(
    null
  );
  // Extract the needed properties
  const secureMessageDetails = contactInfo?.secureMessageDetails;
  const secureMessageDetailsLoading = contactInfo?.secureMessageDetailsLoading;
  const secureMessageDetailsError = contactInfo?.secureMessageDetailsError;

  const dispatch = useDispatch();
  useEffect(() => {
    if (messageId && customerId && accountId) {
      setLocalLoader(true);

      // Dispatch action to fetch message details
      dispatch(
        secureMessageDetailsRequest({
          accountId,
          customerId,
          detailId: messageId,
        })
      );
    }
  }, [messageId, customerId, accountId, dispatch]);

  useEffect(() => {
    if (secureMessageDetails) {
      console.log('Message details received:', secureMessageDetails);

      const category = categoryListForWeb?.filter(
        (item: Item) => item?.value == secureMessageDetails?.category
      );

      const categoryReason = Object.entries(secureMessageListInfo)
        .filter(([item]) => item.includes('FOR_WEB'))
        .filter(([item, value]) => {
          if (
            item.split('_').slice(0, -2).join(' ') ===
            secureMessageDetails?.category?.toUpperCase()
          ) {
            return value;
          }
        });

      const reasonArray = categoryReason[0]?.[1] as Item[] | undefined;
      const reason = reasonArray?.filter((item: Item) => {
        return item?.value === secureMessageDetails?.reason;
      });

      setMessageDetails({
        ...secureMessageDetails,
        category: category[0]?.key,
        reason: reason?.[0]?.key,
      });
      setLocalLoader(false);
    }
  }, [secureMessageDetails, categoryListForWeb]);

  useEffect(() => {
    if (secureMessageDetailsError) {
      console.error(
        'Error fetching message details:',
        secureMessageDetailsError
      );
      setLocalLoader(false);
    }
  }, [secureMessageDetailsError]);

  const getDisplayStatus = (status: string) => {
    if (!status) return '';

    switch (status.toUpperCase()) {
      case 'APPROVED':
        return `${secureMessageErrorInfo?.complete}`;
      case 'PENDING':
        return `${secureMessageErrorInfo?.submitted}`;
      default:
        return `${secureMessageErrorInfo?.submitted}`;
    }
  };

  const setupLocale = () => {
    try {
      const deviceLocale = localStorage.getItem('language');
      const localeToUse = deviceLocale === 'fr' ? 'fr' : 'en';

      moment.locale(localeToUse);

      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };
  const locale = setupLocale();
  console.log('message', messageId, secureMessageDetailsError, messageDetails);
  if (secureMessageDetailsError) {
    return (
      <section
        aria-labelledby="update-details-heading"
        className="mx-auto bg-white border border-light-gray-border rounded-xl shadow-sm p-6 text-sm text-black h-[80vh] overflow-y-auto"
      >
        <p className="text-[16px] font-[650] text-black ">
          Oops! Something went wrong. Please try again later.
        </p>
      </section>
    );
  }
  return (
    <>
      {messageDetails && !localLoader ? (
        <section
          aria-labelledby="update-details-heading"
          className="mx-auto bg-white border-none md:border border-light-gray-border rounded-xl shadow-sm md:p-6 p-[15px] text-sm text-black h-[95vh] md:h-[80vh]  md:overflow-y-auto"
        >
          <h2 id="update-details-heading" className="sr-only">
            Update details
          </h2>

          <div className="flex flex-row gap-8 mb-4">
            <div className="flex flex-col gap-4">
              <span
                className="font-[550] text-black text-[16px]"
                aria-label={rb_secure_message?.dateTitle}
              >
                {rb_secure_message?.dateTitle}
              </span>
              <span
                className="font-[550] text-black text-[16px]"
                aria-label={
                  rb_secure_message?.secureMessageInfo?.confirmationTitle
                }
              >
                {rb_secure_message?.secureMessageInfo?.confirmationTitle ||
                  'Confirmation no.'}
              </span>
              <span
                className="font-[550] text-black text-[16px]"
                aria-label={rb_secure_message?.secureMessageInfo?.statusTitle}
              >
                {rb_secure_message?.secureMessageInfo?.statusTitle || 'Status'}
              </span>
              <span
                className="font-[550] text-black text-[16px]"
                aria-label={rb_secure_message?.categoryTitle}
              >
                {rb_secure_message?.categoryTitle}
              </span>
              <span
                className="font-[550] text-black text-[16px]"
                aria-label={rb_secure_message?.reasonTitle}
              >
                {rb_secure_message?.reasonTitle}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span
                className="font-[450] text-black text-[16px]"
                aria-label={messageDetails.requestDate}
              >
                {(messageDetails?.requestDate &&
                  moment(messageDetails.requestDate)
                    .locale(locale)
                    .format('dddd, MMMM D, YYYY')) ||
                  ''}
              </span>
              <span
                className="font-[450] text-black text-[16px]"
                aria-label={messageDetails?.confirmationNumber}
              >
                {' '}
                {messageDetails?.confirmationNumber || messageId || '_ _'}
              </span>
              <span
                className="font-[450] text-black text-[16px]"
                aria-label={messageDetails?.status}
              >
                {getDisplayStatus(messageDetails?.status || 'pending')}
              </span>
              <span
                className="font-[450] text-black text-[16px]"
                aria-label={messageDetails?.category}
              >
                {messageDetails?.category || 'Profile update'}
              </span>
              <span
                className="font-[450] text-black text-[16px]"
                aria-label={messageDetails.reason}
              >
                {' '}
                {messageDetails.reason || 'Other'}
              </span>
            </div>
          </div>

          <div className="mb-4">
            <h3
              className="font-[550] text-black text-[16px] mb-1"
              id="comments-label"
              aria-label={rb_secure_message?.commentTitle}
            >
              {rb_secure_message?.commentTitle}
            </h3>
            <p
              aria-labelledby="comments-label"
              className="text-[#1F1F1F] text-[16px] font-[450]"
              aria-label={messageDetails?.comments}
            >
              {' '}
              {messageDetails?.comments || '--'}
            </p>
          </div>

          {messageDetails?.agentComments && (
            <div className="border-t border-light-gray-border pt-4">
              <h3
                className="font-[550] text-black text-[16px] mb-2"
                id="agent-comments-label"
                aria-label={rb_secure_message?.secureMessageInfo.agentComment}
              >
                {rb_secure_message?.secureMessageInfo.agentComment}
              </h3>
              <p
                className="text-[#1F1F1F] text-[16px] font-[450] mb-1"
                id="agent-comments-meta"
                aria-label={`${rb_secure_message.secureMessageInfo.postedOn} ${messageDetails?.lastUpdatedTime}`}
              >
                {rb_secure_message.secureMessageInfo.postedOn}{' '}
                {moment(messageDetails?.lastUpdatedTime).format(
                  'MMM DD YYYY'
                ) || '--'}
              </p>
              <p
                aria-labelledby="agent-comments-label agent-comments-meta"
                className="text-[#1F1F1F] text-[16px] font-[450]"
                aria-label={messageDetails?.agentComments}
              >
                {messageDetails?.agentComments || '--'}
              </p>
            </div>
          )}
        </section>
      ) : (
        <div className=" flex justify-center items-center mx-auto bg-white border border-light-gray-border rounded-xl shadow-sm p-6 text-sm text-black h-[80vh] overflow-y-auto">
          <Spinner aria-label="Loading statements" />
        </div>
      )}
    </>
  );
}
